module.exports = __webpack_public_path__ + "img/location.2f632433.svg";